<span [style.color]="color ? color : 'inherit'" [style.border-color]="color ? color : 'inherit'" class="px-2">
  {{ value }}
</span>
